export const CONTAINER_ID = 'root';